var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunitySetup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 24,
    viewBox: "0 0 23 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 10.0834L17.3931 10.7013C18.7091 11.0961 19.3671 11.2936 19.746 11.8028C20.1249 12.3121 20.1249 12.9991 20.1249 14.373V21.5834",
    stroke: "#423F5A",
    strokeWidth: 1.4375,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.66675 9.125H10.5417M7.66675 12.9583H10.5417",
    stroke: "#423F5A",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4999 21.5833V18.7083C11.4999 17.8048 11.4999 17.353 11.2192 17.0723C10.9385 16.7916 10.4868 16.7916 9.58325 16.7916H8.62492C7.72139 16.7916 7.26963 16.7916 6.98894 17.0723C6.70825 17.353 6.70825 17.8048 6.70825 18.7083V21.5833",
    stroke: "#423F5A",
    strokeWidth: 1.4375,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.91675 21.5834H21.0834",
    stroke: "#423F5A",
    strokeWidth: 1.4375,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.875 21.5833V6.93732C2.875 4.53118 2.875 3.32811 3.63321 2.73119C4.39144 2.13427 5.50794 2.45836 7.74096 3.10653L12.5326 4.49738C13.8801 4.88852 14.5539 5.08409 14.9436 5.61713C15.3333 6.15017 15.3333 6.87617 15.3333 8.32817V21.5833",
    stroke: "#423F5A",
    strokeWidth: 1.4375,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunitySetup);
export default __webpack_public_path__ + "static/media/community-setup.5b0f211695140c85c5fbd73f724e04a2.svg";
export { ForwardRef as ReactComponent };